import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './product-use-in.css';

const ProductApplication = () => {
  const [position, setPosition] = useState(0);

  const logos = [
    {
      id: 1,
      image: '/assets/product-application-logos/31349582_restaurant_vintage_logo_02.jpg',
      title: "Bakeries",
      description: "Fresh Goods"
    },
    {
      id: 2,
      image: '/assets/product-application-logos/3d-store-shop-front-with-big-windows-white.jpg',
      title: "Store",
      description: "Organic Products"
    },
    {
      id: 3,
      image: '/assets/product-application-logos/380287018_10526c26-3098-499c-9ba1-ff6212c64942.jpg',
      title: "Boutique",
      description: "Handmade"
    },
    {
      id: 4,
      image: '/assets/product-application-logos/328417920_8404b753-fb37-4a94-be30-7a73344de8b0.jpg',
      title: "Restaurant",
      description: "Fine Dining"
    },
    {
      id: 5,
      image: '/assets/product-application-logos/369304833_5ba49f97-94f7-4f06-9d37-f8307c594572.jpg',
      title: "Hotel",
      description: "Natural"
    },
    {
      id: 6,
      image: '/assets/product-application-logos/sketch-pharmacy-facade-city-street-classic-style-building-with-sign-saying-pharmacy-simple.jpg',
      title: "Pharmacy",
      description: "Health Care"
    },
    {
      id: 7,
      image: '/assets/product-application-logos/paper-bag-filled-with-various-fresh-vegetables-fruits.jpg',
      title: "grocery",
      description: "Daily Needs"
    }
  ];
  
  const extendedLogos = [...logos, ...logos];

  useEffect(() => {
    const interval = setInterval(() => {
      setPosition((prev) => {
        const next = prev + 1;
        if (next >= logos.length) {
          return 0;
        }
        return next;
      });
    }, 3000);

    return () => clearInterval(interval);
  }, [logos.length]);

  return (
    <div className="product-application-outer-wrapper">
      <div className="product-application-wrapper">
        <div className="product-slider">
          <div className="container">
            <div className="text-center mb-5">
              <h1 className="main-heading text-black">
                Driving Success Across Industries
              </h1>
            </div>
            
            <div 
              className="logo-container"
              style={{
                transform: `translateX(-${position * 20}%)`
              }}
            >
              {extendedLogos.map((logo, index) => (
                <div key={`${logo.id}-${index}`} className="logo-item">
                  <div className="logo-content">
                    <div className="logo-wrapper">
                      <img 
                        src={logo.image} 
                        alt={logo.title}
                        className="logo-image"
                      />
                    </div>
                    <h6 className="product-uses-sub">{logo.title}</h6>
                    <p className="product-uses-description text-muted">{logo.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductApplication;